export const Type = {
  PRODUCT_CATEGORY_GET_ASYNC: "productCategoryGetAsync",
  PRODUCT_CATEGORY_GET_SUCCESS: "productCategoryGetSuccess",
  PRODUCT_CATEGORY_GET_FAILURE: "productCategoryGetFailure",
};
